import { Notyf } from 'notyf';

// notyf inserts object icons via textContent, so markup must be passed as a string.
const icon = path =>
  `<span class="wm-toast__icon"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${path}</svg></span>`;

const notyf = new Notyf({
  duration: 3500,
  dismissible: true,
  ripple: false,
  position: {
    x: 'right',
    y: 'top',
  },
  types: [
    {
      type: 'success',
      className: 'wm-toast wm-toast--success',
      background: 'transparent',
      icon: icon('<path d="M20 6 9 17l-5-5"/>'),
    },
    {
      type: 'error',
      className: 'wm-toast wm-toast--error',
      background: 'transparent',
      icon: icon('<path d="M18 6 6 18"/><path d="m6 6 12 12"/>'),
    },
  ],
});

export const notify = (type, message) => {
  if (!message) return;
  notyf.open({
    type,
    message,
  });
};
